<template>
    <div class="neueBestellungHolder">
        <router-view></router-view>
        <div class="neueBestellungTop">
            <div class="neueBestellungTopButtonHolder">
                <button id="checkButton" class="neueBestellungsButton" @click="checkAll()">none</button>
                <!-- <div class="emptyDiv"></div> -->
                <button id="neueBestellungBuchen" class="neueBestellungsButton" @click="abuchen()"
                        :disabled="neueBestellung.length < 1">buchen
                </button>
                <select v-model="delimiter" class="neueBestellungsButton">
                    <option value=";">;</option>
                    <option value=",">,</option>
                </select>
            </div>
        </div>
        <div>
            <div v-if="verbrauchsMat === '5'">
                Neue Bestellung Küchen Material
            </div>
            <div v-if="verbrauchsMat === '4'">
                Neue Bestellung Sekundär Material
            </div>
            <div v-if="verbrauchsMat === '3'">
                Neue Bestellung EM Material
            </div>
            <div v-if="verbrauchsMat === '2'">
                Neue Bestellung SFS Material
            </div>
            <div v-if="verbrauchsMat === '1'">
                Neue Bestellung SRM Material
            </div>
            <div v-if="verbrauchsMat === '0'">
                Neue Bestellung Primär Material
            </div>
        </div>
        <div class="neueBestellungItemHolder">
            <table class="neueBestellungTable">
                <tr>
                    <th class="neueBestellungHeadCells">Bestellen</th>
                    <!-- <th class="neueBestellungHeadCells">VerbrauchsMat</th> -->
                    <th class="neueBestellungHeadCells">Menge</th>
                    <th class="neueBestellungHeadCells">Me-Einheit</th>
                    <th class="neueBestellungHeadCells">SBB Art. Nummer</th>
                    <th class="neueBestellungHeadCells">SAP-Bezeichnung</th>
                </tr>
                <tr v-for="item in neueBestellung"
                    :key="item.id"
                    class="neueBestellungItem"
                >
                    <td class="neueBestellungCellsCheck">
                        <label class="neubestellCheckBox">
                            <input type="checkbox" v-model="item.checked">
                            <span class="neubestellCheckmark"></span>
                        </label>
                    </td>
                    <!-- <td class="neueBestellungCellsCheck">
                        <label class="neubestellCheckBox">
                            <input type="checkbox" v-model="item.verbrauchsMat" disabled>
                            <span class="neubestellCheckmark"></span>
                        </label>
                    </td> -->
                    <td class="neueBestellungCells" @click="openArtInfo(item.id)">{{item.bestellAmount}}
                        {{item.mengeneinheit}}
                    </td>
                    <td class="neueBestellungCells" @click="openArtInfo(item.id)" v-if="!item.packung">
                        {{item.mengeneinheit}}
                    </td>
                    <td class="neueBestellungCells" @click="openArtInfo(item.id)" v-if="item.packung">
                        {{item.packungAmount}} Packung à {{item.StkProEinheit}} {{item.mengeneinheit}}
                    </td>
                    <td class="neueBestellungCells" @click="openArtInfo(item.id)">{{item.artnum}}</td>
                    <td class="neueBestellungCells" @click="openArtInfo(item.id)">{{item.shorttxt}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import http from '../../http/http';

export default {
    components: {},
    data() {
        return {
            delimiter: ';'
        }
    },
    props: {
        stao: {
            type: String,
            default: '1'
        },
        verbrauchsMat: {
            type: String,
            default: '0'
        }
    },
    computed: {
        neueBestellung() {
            return this.$store.getters['lager/neueBestellung'];
        },
        user() {
            return this.$store.getters['user/userData'];
        },
        apiurl() {
            return http.defaults.baseURL;
        },
        userLev() {
            return this.$store.getters['user/autLev'];
        }
    },
    watch: {
        verbrauchsMat: function() {
            this.$store.dispatch('lager/neueBestellung', { stao: this.stao, verbrauchsMat: this.verbrauchsMat });
        }
    },
    methods: {
        openArtInfo(id) {
            if (this.userLev.indexOf(6) > -1) {
                this.$router.push('artdetails/' + id + '/');
            }
        },
        abuchen() {
            const data = {
                stao: this.stao,
                delimiter: this.delimiter,
                art: this.neueBestellung,
                userName: this.user.lname + ' ' + this.user.fname,
                userId: this.user.id,
                url: this.apiurl
            };

            this.$store.dispatch('lager/bestellungBuchen', data);

            document.getElementById('neueBestellungBuchen').disabled = true;
        },
        checkAll() {
            let buttontxt = 'none';
            // // if the button is on all check the boxes else not
            // if(document.getElementById("checkButton").innerHTML == "all"){

            //     buttontxt = 'verbrauch';

            //     for(var i = 0; i< this.neueBestellung.length;i++){
            //         this.neueBestellung[i].checked = true;
            //     }
            // }
            // else if(document.getElementById("checkButton").innerHTML == "verbrauch"){

            //     buttontxt = 'none';

            //     for(var i = 0; i< this.neueBestellung.length;i++){
            //         if(this.neueBestellung[i].verbrauchsMat){
            //             this.neueBestellung[i].checked = true;
            //         }
            //         else{
            //             this.neueBestellung[i].checked = false;
            //         }
            //     }
            // }
            // else{

            //     buttontxt = 'all';

            //     for(var i = 0; i< this.neueBestellung.length;i++){
            //         this.neueBestellung[i].checked = false;
            //     }

            // }

            if (document.getElementById('checkButton').innerHTML === 'all') {
                buttontxt = 'none';

                for (let i = 0; i < this.neueBestellung.length; i++) {
                    this.neueBestellung[i].checked = true;
                }
            } else {
                buttontxt = 'all';

                for (let i = 0; i < this.neueBestellung.length; i++) {
                    this.neueBestellung[i].checked = false;
                }
            }

            document.getElementById('checkButton').innerHTML = buttontxt;
        }

    },
    beforeDestroy() {
    },
    created() {
        this.$store.dispatch('lager/neueBestellung', { stao: this.stao, verbrauchsMat: this.verbrauchsMat });
    }
}
</script>

<style scoped lang="scss">

    .neueBestellungHolder {
        position: absolute;
        width: 100%;
        height: 100vh;
        /*overflow-y: scroll;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
    }

    .neueBestellungTop {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        width: 100%;
        height: 80px;
        background-color: $color-white;
    }

    .neueBestellungTopButtonHolder {
        height: 100%;
    }

    .neueBestellungsButton {
        height: 100%;
        font-size: 2rem;
    }

    .emptyDiv {

    }

    .neueBestellungItemHolder {
        display: flex;
        flex-direction: column;
        background-color: $color-white;
        width: 100%;
        height: 100%;
        overflow: scroll;
    }

    .neueBestellungTable {
        border-collapse: collapse;
        margin-left: 1.25rem;
    }

    .neueBestellungItem {
        font-size: 1.25rem;
        border: none;
        padding: 0.375rem;
        cursor: pointer;
        height: 2.5rem;
    }

    .neueBestellungItem:hover {
        background-color: $color-gray;
    }

    .neueBestellungItem:active {
        background-color: $color-green;
    }

    .neueBestellungHeadCells {
        padding: 0.625rem;
    }

    .neueBestellungCells {
        border: none;
        padding: 0.625rem;
        text-align: center;
    }

    .neueBestellungCellsCheck {
        /*display:flex;*/
        height: 2rem;
        justify-content: center;
        align-items: center;
    }

    /*============ custom checkbox =============*/
    .neubestellCheckBox {
        display: block;
        position: relative;
        padding-left: 35px;
        margin-bottom: 12px;
        cursor: pointer;
        user-select: none;
        font-size: 22px;
    }

    /* Hide the browser's default checkbox */
    .neubestellCheckBox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* On mouse-over, add a grey background color */
    .neubestellCheckBox:hover input ~ .neubestellCheckmark {
        background-color: #ccc;
    }

    /* Create a custom checkbox */
    .neubestellCheckmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.5rem;
        width: 1.5rem;
        background-color: #eee;
    }

    /* When the checkbox is checked, add a blue background */
    .neubestellCheckBox input:checked ~ .neubestellCheckmark {
        background-color: #2196F3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .neubestellCheckmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .neubestellCheckBox input:checked ~ .neubestellCheckmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .neubestellCheckBox .neubestellCheckmark:after {
        left: 9px;
        top: 0.375rem;
        width: 0.375rem;
        height: 0.625rem;
        border: solid $color-white;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
    }

    @include medium {

    }

    @include extra-large {

        .neueBestellungHolder {
            font-size: 1.25rem;
        }

    }

</style>
